<div *ngIf="!isCookiePresent" class="cookie-popup" role="alertdialog" tabindex="-1">
    <div class="container">
        <img src="assets/images/cookie-banner.svg" alt="Cookie Banner" class="cookie-img">

        <h3>Zero Calorie Cookies</h3>
        <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="16px">
            <p>
                We use cookies to enhance your experience.
                By continuing, you are agreeing to our use of cookies.
                Here is our recently updated our
                <a class="text-primary" href="/policy/privacy-policy">privacy policy.</a>
            </p>

            <button fxFlex="30" mat-raised-button color="primary" (click)="toggleCookie()">
                Accept
            </button>
        </div>
    </div>
</div>